import Vue from "vue";
import VxTooltip from "./../layouts/components/vx-tooltip/VxTooltip.vue";
import VxCard from "./../components/VxCard.vue";
import VxList from "./../components/VxList.vue";
import VxBreadcrumb from "./../layouts/components/VxBreadcrumb.vue";
import FeatherIcon from "./../components/FeatherIcon.vue";
import VxInputGroup from "./../components/VxInputGroup.vue";
import FetchError from "./../components/FetchError.vue";
import Loader from "./../components/Loader.vue";
import UnlimitedList from "./../components/UnlimitedList.vue";
import Counter from "./../components/Counter.vue";
import ShadowButton from "./../components/ShadowButton.vue";
import VueStarRating from "vue-star-rating";
import InfiniteLoading from "vue-infinite-loading";
import ImageReader from "./../components/image/ImageReader.vue";
import ImageCropperInput from "./../components/image/ImageCropperInput.vue";

import VueAwesomeSwiper from 'vue-awesome-swiper';

import 'swiper/css/swiper.css';

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);
Vue.component(FetchError.name, FetchError);
Vue.component(Loader.name, Loader);
Vue.component(UnlimitedList.name, UnlimitedList);
Vue.component(ShadowButton.name, ShadowButton);
Vue.component(Counter.name, Counter);
Vue.component("vue-star-rating", VueStarRating);
Vue.component("image-reader", ImageReader);
Vue.component("image-cropper-input", ImageCropperInput);
Vue.use(InfiniteLoading);
Vue.use(VueAwesomeSwiper);

/**
 * Vue html to paper
 */
import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=no", "titlebar=no", "scrollbars=no", "header=no"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "http://localhost:8080/CustomerPrint.css",
    "public/landscape.css",
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  // windowTitle: window.document.title, // override the window title
};

Vue.use(VueHtmlToPaper, options);

/**
 * Vue select
 */
import vSelect from "vue-select";

vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) =>
      createElement("feather-icon", {
        props: {
          icon: "XIcon",
          svgClasses: "w-4 h-4 mt-1",
        },
      }),
  },
  OpenIndicator: {
    render: (createElement) =>
      createElement("feather-icon", {
        props: {
          icon: "ChevronDownIcon",
          svgClasses: "w-5 h-5",
        },
      }),
  },
});

Vue.component(vSelect);

// /**
//  * Leaflet map
//  */
// import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
// import "leaflet/dist/leaflet.css";

// Vue.component("l-map", LMap);
// Vue.component("l-tile-layer", LTileLayer);
// Vue.component("l-marker", LMarker);
